<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_two_phase_method_code'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <table class="confirmation-code-table">
                        <tr>
                            <td class="confirmation-code-block">
                                {{shownConfirmationCode}}
                            </td>
                            <td>
                                <el-progress type="circle" width="60" :percentage="percentage" :status="status" :color="colors"></el-progress>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="dialog-body-small">
                    <span v-html="$t('message.info_two_phase_method_code_warn1')"></span><br>
                    <span v-html="$t('message.info_two_phase_method_code_warn2')"></span><br>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="cancel()" v-t="'message.button_back'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';

export default {
    data() {
        return {
            percentage: 0,
            status: 'success',
            colors: [
                {color: '#70a838', percentage: 70},
                {color: '#d8aa36', percentage: 90},
                {color: '#d55169', percentage: 100},
            ],
            showingLoopId: 0,
            periodTOTP: 30000, // milli seconds
            periodLoop: 100, // milli seconds
            nextRefreshTime: null,
            refreshCounter: 0,
            shownConfirmationCode: "",
            confirmationCode: "",
            seed: null,
        };
    },
    methods: {
        showingLoop() {
            // no showing time
            if (this.refreshCounter < 5) {
                this.percentage = 0;
                this.shownConfirmationCode = "";
                this.refreshCounter++;
                return;
            }

            // seed not got yet
            let seed = this.seed;
            if (seed == null) {
                this.shownConfirmationCode = "";
                return;
            }

            this.shownConfirmationCode = this.confirmationCode;
            let currentTime = this.getCurrentTimeMillis();
            if (currentTime >= this.nextRefreshTime) {
                this.refresh(currentTime, seed, true);
                return;
            }
            let percentage = Math.floor( (currentTime - this.nextRefreshTime + this.periodTOTP) / this.periodTOTP * 100 );
            if (this.percentage == percentage) {
                return;
            }

            this.percentage = percentage;
            if (percentage < 70) {
                this.status = 'success';
            } else if (percentage < 90) {
                this.status = 'warning';
            } else {
                this.status = 'exception';
            }
        },
        getCurrentTimeMillis() {
            // let date = new Date();
            // return date.getTime();
            return Date.now();
        },
        refresh(currentTimeMillis, seed, initCounter = false) {
            let baseTime = Math.floor(currentTimeMillis / this.periodTOTP) * this.periodTOTP;
            this.nextRefreshTime = baseTime + this.periodTOTP;
            if (initCounter) {
                this.refreshCounter = 0;
            }
            this.confirmationCode = this.getConfirmationCode(baseTime, seed);
        },
        getSeed(refreshSeed = false) {
            let self = this;
            server.post('/gettenanttotp', {refreshSeed: refreshSeed}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let seed = res.data.totp;
                        let currentTime = self.getCurrentTimeMillis();
                        self.refresh(currentTime, seed);
                        // value should be set after refresh() is called
                        self.seed = seed;
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getSeed", error);
            });
        },
        cancel() {
            // loop end
            clearInterval(this.showingLoopId);
            this.$emit('cancel');
        },
        getConfirmationCode(baseTime, seed) {
            if (seed == null) {
                return "";
            }
            let T = baseTime / this.periodTOTP;
            let steps = T.toString(16).toUpperCase();
            return this.generateTOTP(seed, steps, 6);
        },
        generateTOTP(key, time, codeDigits) {
            while (time.length < 16) {
                time = '0' + time;
            }

            let msg = this.getBuffer(time);
            let k = this.getBuffer(key);

            const crypto = require('crypto');
            const hmac = crypto.createHmac('sha1', k);
            hmac.write(msg);
            hmac.end();
            let hash = hmac.read().toString('hex');

            let hashArray = new Array();
            for (let index = 0; index < hash.length; index += 2) {
                let elem = parseInt(hash.substr(index, 2), 16);
                hashArray.push(elem);
            }

            let offset = hashArray[hashArray.length - 1] & 0xf;
            let binary = ((hashArray[offset] & 0x7f) << 24) |
                ((hashArray[offset + 1] & 0xff) << 16) |
                ((hashArray[offset + 2] & 0xff) << 8) |
                (hashArray[offset + 3] & 0xff);

            // TODO: use codeDigits and make this result variable
            let otp = binary % 1000000;

            let result = otp.toString(10);
            while (result.length < 6) {
                result = '0' + result;
            }
            return result;
        },
        getBuffer(str) {
            let bufSize = str.length / 2;
            var result = Buffer.alloc(bufSize);
            for (let index = 0; index < bufSize; index ++) {
                let number = parseInt(str.substr(2 * index, 2), 16);
                result.writeUInt8(number, index);
            }
            return result;
        },
    },
    created: function() {
        this.getSeed();

        // loop start
        this.showingLoopId = setInterval(this.showingLoop, this.periodLoop);
    },
    mounted: function() {
    },
    watch: {
    },
    props: ['appData' ]
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}
.el-select.select-two-phase-method-item {
    width: 350px;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.confirmation-code-table {
    height: 120px;
}

.confirmation-code-block {
    width: 280px;
    font-size: 60px;
}

</style>
